import "./Gallery.module.css";
import MainNavigation from "@/reusable_sections/Header";
import VibrantTransformations from "./sections/VibrantTransformations";
import RecentTransformations from "./sections/RecentTransformations";
import SiteFooter from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <MainNavigation />
      <VibrantTransformations />
      <RecentTransformations />
      <SiteFooter />
    </div>;
}